import { Route } from '@angular/router';
import { provideTranslocoScope } from '@jsverse/transloco';
import { template } from 'typesafe-routes';

import { ensureFeatureFlag } from '@customer-portal/flags';
import { activeCustomerGuard } from '@customer-portal/shared/account/data-access';
import { appRouteMap } from '@customer-portal/shared/routing';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: async () => (await import('./core')).NscpPageLayout,
    providers: [
      provideTranslocoScope(
        'account',
        'companyDetails',
        'core',
        'customerConsumption',
        'customerContracts',
        'dashboard',
        'memberManagement',
        'customerInvoices',
        'accountDetails',
        'customerSupport',
        'customerChat',
      ),
    ],
    children: [
      {
        path: '',
        loadChildren: async () => (await import('@customer-portal/domains/dashboard/routes')).DASHBOARD_ROUTES,
        providers: [provideTranslocoScope('account', 'dashboard', 'forms', 'statistics')],
      },
      {
        path: template(appRouteMap._.companyDetails),
        canActivate: [activeCustomerGuard],
        loadChildren: async () => (await import('@customer-portal/domains/company-details/routes')).COMPANY_DETAILS_ROUTES,
        data: {
          breadcrumb: 'companyDetails.details.pageTitle',
        },
      },
      {
        path: template(appRouteMap._.customerConsumption),
        loadChildren: async () => (await import('@customer-portal/domains/customer-consumption/routes')).CUSTOMER_CONSUMPTION_ROUTES,
        data: {
          breadcrumb: 'customerConsumption.consumption.pageTitle',
        },
      },
      {
        path: template(appRouteMap._.customerInvoices),
        loadChildren: async () => (await import('@customer-portal/domains/customer-invoicing/routes')).CUSTOMER_INVOICING_ROUTES,
        data: {
          breadcrumb: 'customerInvoices.overview.pageTitle',
        },
      },
      {
        path: template(appRouteMap._.customerContracts),
        canActivate: [activeCustomerGuard],
        loadChildren: async () => (await import('@customer-portal/domains/customer-contracts/routes')).CUSTOMER_CONTRACTS_ROUTES,
        data: {
          breadcrumb: 'customerContracts.menuTitle',
        },
      },
      {
        path: template(appRouteMap._.memberManagement),
        loadChildren: async () => (await import('@customer-portal/domains/member-management/routes')).MEMBER_MANAGEMENT_ROUTES,
        data: {
          breadcrumb: 'memberManagement.list.pageTitle',
        },
      },
      {
        path: template(appRouteMap._.customerSupport),
        canActivate: [activeCustomerGuard],
        loadChildren: async () => (await import('@customer-portal/domains/customer-support/routes')).CUSTOMER_SUPPORT_ROUTES,
        data: {
          breadcrumb: 'customerSupport.overview.pageTitle',
        },
      },
      {
        path: template(appRouteMap._.accountDetails),
        loadChildren: async () => (await import('@customer-portal/domains/account-details/routes')).ACCOUNT_DETAILS_ROUTES,
        data: {
          breadcrumb: 'accountDetails.details.pageTitle',
        },
      },

      {
        path: template(appRouteMap._.customerChat),
        canActivate: [activeCustomerGuard, ensureFeatureFlag('ff-poc-customer-chat')],
        loadChildren: async () => (await import('@customer-portal/domains/customer-chat/routes')).CUSTOMER_CHAT_ROUTES,
        providers: [provideTranslocoScope('core', 'customerChat')],
        data: {
          breadcrumb: 'customerChat.menuTitle',
        },
      },
      {
        path: 'demo',
        canActivate: [ensureFeatureFlag('view-component-demo')],
        loadComponent: async () => (await import('./core')).RouteDemo,
        providers: [provideTranslocoScope('account', 'core', 'forms')],
        data: {
          breadcrumb: 'Demo',
          screenName: 'Demo',
        },
      },
      {
        path: 'server-error',
        loadComponent: async () => (await import('./core')).RouteServerError,
        data: {
          breadcrumb: 'core.serverError.breadcrumb',
          screenName: 'ServerError',
        },
      },
      {
        path: 'pagina-niet-gevonden',
        loadComponent: async () => (await import('./core')).RoutePageNotFound,
        data: {
          breadcrumb: 'core.pageNotFound.breadcrumb',
          screenName: 'PageNotFound',
        },
      },
      {
        path: '**',
        redirectTo: 'pagina-niet-gevonden',
      },
    ],
  },
];
